<template>
  <el-container>
    <el-main>
      <div style="margin: 50px 100px">
        <div>
          <h2 style="font-size: 30px; color: #617173;margin-top: 10px">
            须知
          </h2>
          <el-divider style="width: 1200px;margin-left: 30px" />
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            根據香港法理依據，華夏書院(註冊編號 ED/1/31569/64)是香港專上教育機構之一, 受《香港法例第0279章 -- 教育條例》監管，獲香港特別行政區教育局批准可以舉辦專上教育課程的機構。香港專上教育亦稱香港高等教育，可以說是在整個香港教育制度下最高層次的。學術範圍非常廣泛，程度亦有深淺之分，課程的內容皆是專門及專業的。香港目前正在營辦的專上教育機構約有五十間，包括法定大學、法定學院、註冊專上學院、 職業訓練院校、 一般院校和佛教院校
          </p>
          <el-divider style="width: 1200px;margin-left: 30px" />
          <p style="font-size: 15px; color: #617173;">
            香港特區政府成立後，提倡中醫，設立中醫業管理及培訓委員會。本院於2005年起接受政府工商科技局資助，提供中醫培訓課程，並成為香港中醫管理委員會核准之中醫培訓機構（認可中醫培訓機構編號CME-PP0022）。本院其後與湖北中醫學院合辦碩士、博士課程，畢業生可因此參加全國中醫執業資格試。
          </p>
          <el-divider style="width: 1200px;margin-left: 30px" />
          <p style="font-size: 15px; color: #617173;">
            華夏書院有限公司於2013年創立「華夏青年中醫協會」，旨在踐行已故校監列航飛先生弘揚中華文化之畢生志業。本會以「以醫載道，文脈新生」為核心理念，聚焦青年中醫師群體，構建傳統文化傳承與中醫藥發展深度融合的創新平臺，實現從學術精研到文化傳播的立體化使命傳承。
          </p>
          <el-divider style="width: 1200px;margin-left: 30px" />
          <p style="font-size: 15px; color: #617173;">
            根據《中醫藥條例》，註冊中醫必須符合香港中醫藥管理委員會中醫組訂定的註冊中醫進修中醫藥學要求，才可續領執業證明書。中醫組已於2005年2月28日起正式實施註冊中醫進修中醫藥學，並已甄選進修機制下認可的「行政機構」及「提供進修項目機構」。有關名單可從本網頁下載。
            註冊中醫須自行選擇一間「認可行政機構」開設個人進修資料庫。如註冊中醫同時在兩間「行政機構」開設了進修資料庫，須儘快取消其中一間「行政機構」開設的資料庫，並自行取回有關進修資料交予所選擇的一間「行政機構」。
          </p>
          <el-divider style="width: 1200px;margin-left: 30px" />
          <p style="font-size: 15px; color: #617173;">
            註 冊 中 醫 執 業 證 明 書 通 常 需 每 三 年 續 領 一 次。在續領時，註冊中醫必須符合中醫組訂定的進 修中醫藥學的要求，才可續領執業證明書。因此， 每位註冊中醫的進修中醫藥學周期，在一般情況下 由其執業證明書生效日期開始至有效期結束為止， 通常以三年為一周期。註冊中醫必須在每個 周期內 參與進修活動，取得不少於 60 分（以三年計）的進 修分數要求。在一個進修
          </p>
          <el-divider style="width: 1200px;margin-left: 30px" />
          <h2 style="font-size: 30px; color: #617173;margin-top: 30px">
            香港中醫執業資格考試要點
          </h2>
          <el-divider style="width: 1200px;margin-left: 30px" />
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            以下是關於香港中醫執業資格考試要求：
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            根據《2024年中醫執業資格試考生手冊》，考試要求及流程：
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 20px">
            1. 考試結構與順序
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            筆試（兩部分，均為中文選擇題）：
            卷一：基礎理論與中醫診斷學
            卷二：中藥學、方劑學及臨床學科
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            要求：兩卷可同時報考，或於三年內分開通過（例：2024年過卷一，2026年過卷二）。
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            臨床考試（面試形式）：
            僅限筆試合格者參加，可選擇粵語或普通話（需提前申請）。
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 20px">
            2. 及格分數與成績有效期
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            筆試：總分300分，需達165分（55%）。單卷及格成績自通過日起保留五年（例：2024年過卷一，成績有效期至2029年）。
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            臨床考試：總分200分，需達120分（60%）。
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            考生須在筆試全部合格後五年內通過臨床考試（例：若2025年完成筆試，須於2030年前通過臨床考試）。
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 20px">
            3. 重要時間限制
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            筆試分段合格：若分開報考兩卷，須於三年內完成兩卷（例：2024年報卷一，最遲2027年通過卷二）。
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            臨床考試期限：若五年內未通過臨床考試，需**重新參加並通過筆試（兩卷）**方可再考臨床。
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 20px">
            4. 註冊中醫師資格
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            通過筆試與臨床考試後，可申請成為香港註冊中醫師，兩者缺一不可。
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 20px">
            5. 語言與申請注意事項
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            筆試語言：中文（繁體）。
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            臨床考試語言：需在報名時註明選擇粵語或普通話。
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 20px">
            總結流程圖示
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            完成中醫本科學業 → 2. 通過筆試（兩卷）→ 3. 五年內通過臨床考試 → 4. 註冊成為中醫師
          </p>
          <p style="font-size: 15px; color: #617173; margin-top: 10px">
            若未在時限內完成，需按規則重考相應部分。建議考生合理安排時間，確保成績有效期內完成所有要求.
          </p>
        </div>
      </div>
    </el-main>
    <el-divider style="width: 1350px;margin-left: 30px" />
    <el-footer>
      <div>
        <div style="color: #617173; text-align:center; font-size: 10px;margin-bottom: 10px">
          華夏青年中醫協會
        </div>
        <div style="margin-left: 610px; margin-bottom: 20px">
          <img src="../assets/logo1.png" alt="Logo" style="width: 170px; height: auto">
        </div>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "Activity1"
}
</script>

<style scoped>

</style>
